module.exports = __webpack_public_path__ + "img/c47074e1548e00868ca0156020df9928.15b1e219.webp";